import { Avatar, AvatarGroup, HStack, Text } from '@chakra-ui/react'
import type { PrescriberProfile } from '../../../types/location'

interface PrescriberAvatarGroupProps {
  prescribers: PrescriberProfile[]
  max?: number
}

const AVATAR_COLORS = ['red.500', 'blue.500', 'green.500', 'purple.500', 'orange.500', 'teal.500']

const getAvatarColor = (index: number) => AVATAR_COLORS[index % AVATAR_COLORS.length]

export const PrescriberAvatarGroup = ({ prescribers, max = 5 }: PrescriberAvatarGroupProps) => {
  return (
    <HStack spacing={3}>
      <AvatarGroup size="xs" max={max} spacing="-6px">
        {prescribers.map((prescriber, index) => (
          <Avatar
            key={prescriber.id}
            name={`${prescriber.givenNames} ${prescriber.familyName}`}
            bg={getAvatarColor(index)}
            color="white"
            fontSize="xs"
            fontWeight="bold"
          />
        ))}
      </AvatarGroup>
      <Text fontSize="sm" color="gray.600">
        {prescribers.length} assigned
      </Text>
    </HStack>
  )
}
